declare var require: any;

import * as React from 'react';

import { DialogReduxProvider } from './providers/DialogReduxProvider';
import { Provider } from 'react-redux'
import { DialogSignalRService } from './services/DialogSignalRService';
import { DialogAuthProvider } from './../common/providers/DialogAuthProvider';
import { DialogConfig, DialogClaim, DialogGroup } from './../common/models/DialogConfig';
import { DialogHttpService } from './../common/services/DialogHttpService';

import DialogFeedWrapper from './DialogFeedWrapper';
import DialogHeroWrapper from './DialogHeroWrapper';
import { Store } from 'redux';
import { PreinitializeAction, SetHeroBannerAction } from './actions';
//import DialogHeroWrapper from './DialogHeroWrapper';

const baseConfig: DialogConfig = {
  ServiceUrl: '',
  SignalRHub: '/signalr',
  AppKey: '',
  AppSecret: '',
  ShowAudiences: false,
  GlobalAllowLikes: false,
  GlobalAllowComments: false,
  EnableMessageSnippets: false,
  EnableLinkPreview: false
};

interface DialogProps {
  name: string;
  externalId: string;
  email: string;
  serviceUrl: string;
  hubPath: string;
  appKey: string;
  appSecret: string;
  store?: Store;
  admin?: boolean;
  edit?: Function;
  hero?: boolean;
  audience?: boolean;
  likes?: boolean;
  comments?: boolean;
  groups?: DialogGroup[];
  enableLinkPreview?: boolean;
  enableMessageSnippets?: boolean;
}

class DialogFeed extends React.Component<DialogProps, any> {
  private _store: Store;
  private _srService: DialogSignalRService;
  public constructor(props: DialogProps) {
    super(props);
    this.state = {
      categoriesReady: false
    };
    let claim: DialogClaim = {
      type: 'user',
      isAdmin: false,
      groups: props.groups ? props.groups : [
        {
          type: 'group',
          name: 'Everyone',
          externalId: '3958c591-7817-4c47-92bb-23f6e5c4c5a0'
        }
      ],
      name: props.name,
      externalId: props.externalId
    };
    if(props.admin) {
      claim.isAdmin = true;
      claim.groups.push(
        {
          type: 'group',
          name: 'Fuse Message Admin',
          externalId: '0301DFB9-C0C8-45CD-A073-26F76BCE9F01'
        }
      );
    }
    if(this.props.store) {
      this._store = this.props.store;
    }
    else {
      this._store = DialogReduxProvider.createStore();
    }
    this._store.dispatch(new PreinitializeAction({claim: claim}));
    let config: DialogConfig = Object.assign(baseConfig, {
      ServiceUrl: props.serviceUrl,
      SignalRHub: props.hubPath,
      AppKey: props.appKey,
      AppSecret: props.appSecret,
      Claim: claim,
      ShowAudiences: this.props.audience ? true : false,
      GlobalAllowLikes: this.props.likes ? true : false,
      GlobalAllowComments: this.props.comments ? true : false,
      EnableLinkPreview: this.props.enableLinkPreview ? true : false,
      EnableMessageSnippets: this.props.enableMessageSnippets ? true : false
    });
    let authProvider = new DialogAuthProvider(config);
    let httpService = new DialogHttpService(config, authProvider);
    this._srService = new DialogSignalRService(this._store, config, authProvider);
    httpService.authorize().then(() => {
      if(this.props.hero) {
        httpService.getTabs().then(response => {
          let sortedTabs = response.data.sort((a: any, b: any) => { return a.order - b.order });
          if(sortedTabs.length > 0) {
            let heroImageData = JSON.parse(sortedTabs[0].iconHoverUrl);
            this._store.dispatch(new SetHeroBannerAction({ hero: heroImageData }));
          }
        });
      }
      httpService.getCategories().then(response => {
        let categories = response.data.map((c: any) => { return {id: c.id, name: c.name, icon: { id: 0, src: c.iconUrl }} });
        this._store.dispatch({ type: 'SET_CATEGORIES', payload: categories });
        this._srService.initialize();
      });
    });
  }
  public render() {
    return (
      <div>
        {
          this.props.store &&
          <DialogFeedContainer service={this._srService}></DialogFeedContainer>
        }
        {
          !this.props.store &&
          <Provider store={this._store}>
            <DialogFeedContainer service={this._srService} edit={this.props.edit} hero={this.props.hero} ></DialogFeedContainer>
          </Provider>
        }
      </div>
    );
  }
  public componentWillUnmount() {
    this._srService.close();
  }
}

class DialogFeedContainer extends React.Component<any, {}> {
  public constructor(props: any) {
    super(props);
  }
  public render() {
    return (
      <span>
        { this.props.hero && <DialogHeroWrapper></DialogHeroWrapper>
        }
        <DialogFeedWrapper service={this.props.service} edit={ this.props.edit ? this.props.edit : (id: number) => { console.log(id); } }></DialogFeedWrapper>
      </span>
    );
  }
}

export default DialogFeed;